import { useContext } from 'react';
import { AppConfigContext } from '../contexts/AppConfigContext';
import { type IAppContextShape } from '../types/appConfigTypes';

// A custom hook allows us to test better.
export const useAppConfigContext = (): IAppContextShape => useContext(AppConfigContext) as IAppContextShape;

export default useAppConfigContext;
